<template lang="pug">
    transition(appear, name="fade")
        .election_loading(:class="{ loading: loading }")
            LoadingIcon

</template>

<script>
import LoadingIcon from '../../assets/loading.svg';

export default {
  name: 'loading-overlay',
  props: [ 'loading' ],
  components: { LoadingIcon }
};
</script>

<style lang="scss">
    @import "src/core/scss/global-sass";
    .election_loading {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,0.8);
        border-radius: $m-spacing;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: $m-spacing-x2;

        display: none;
        &.loading {
            display: flex;
        }

        svg {
            width: 40px;
            height: 40px;
            rect {
                fill: #fff;
            }
        }
    }
</style>
